import BaseAPIClient from '~/clientUtils/baseApiClient';

export interface SessionValidationResponse {
    valid: boolean;
    reason?: string;
    user?: {
        customerUserId: string;
        username: string;
        name: string;
        email: string;
    };
}

class SessionApi extends BaseAPIClient {
    constructor() {
        super('', {});
    }

    async updateSession(payload: { [key: string]: any }): Promise<{ success: boolean; error?: string }> {
        // Only send keys that are defined
        const data: Record<string, any> = {};
        Object.keys(payload).forEach((key) => {
            if (payload[key] !== undefined) {
                data[key] = payload[key];
            }
        });
        return this.request({
            method: 'POST',
            url: `/api/session`,
            data,
        });
    }

    async validateSession(): Promise<SessionValidationResponse> {
        return this.request({
            method: 'GET',
            url: `/api/session/validate`,
        });
    }
}

const sessionApi = new SessionApi();

export default sessionApi;
